/**
 * This function calculates the target scroll position based on the element's
 * position relative to the viewport and then scrolls smoothly to it.
 * @param elementId - The ID of the element to scroll to
 * @param scrollPaddingTop - Additional padding to adjust the final scroll position (default: 120px)
 *
 */
export const scrollToElement = (elementId: string, scrollPaddingTop = 120) => {
  const element = document.getElementById(elementId)
  if (element) {
    const scrollPoint = element.getBoundingClientRect().top + window.scrollY - scrollPaddingTop
    window.scroll({
      top: scrollPoint,
      behavior: 'smooth',
    })
  }
}